<app-course-list-filter class="d-block"></app-course-list-filter>
<ng-container *ngIf="(courses$ | async | courseFilter) === false">
  <app-load-indicator description="load your courses"></app-load-indicator>
</ng-container>
<ng-container *ngIf="(courses$ | async); else loading">
  <app-course-listview-list
    [courses]="courses$ | async | courseFilter:courseFilterService.filterIterator | courseListSort:true"
    *ngIf="courseFilterService.courseListDisplayType == 'list'">
  </app-course-listview-list>

  <app-course-listview-grid
    [courses]="courses$ | async | courseFilter:courseFilterService.filterIterator | courseListSort:true"
    *ngIf="courseFilterService.courseListDisplayType == 'grid'">
  </app-course-listview-grid>
  <ng-container *ngIf="(courses$ | async | courseFilter) !== false && (courses$ | async | courseFilter).length == 0">
    <p>No courses match your filter. Please try again.</p>
  </ng-container>
</ng-container>

<ng-template #loading>
  <app-load-indicator description="load your courses"></app-load-indicator>
</ng-template>
